import Swal from "sweetalert2";
import { SettingsActionWorkspaceAccessTokenRequestsApi } from "../../Apis/user/ApiConfig";
import {
    SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_ERROR,
    SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_SUCCESS,
    SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_REQUEST,
} from "../../Types/user/Types";

export const SettingsActionWorkspaceAccessTokenRequestsSuccess = (res) => {
    return {
        type: SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_SUCCESS,
        payload: res,
    };
};
export const SettingsActionWorkspaceAccessTokenRequestsError = (error) => {
    return {
        type: SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_ERROR,
        error: error,
    };
};

export const SettingsActionWorkspaceAccessTokenRequestsRequest = (res) => {
    return {
        type: SETTINGS_ACTION_WORKSPACE_ACCESS_TOKEN_REQUESTS_REQUEST,
        payload: res,
    };
};

export const SettingsActionWorkspaceAccessTokenRequestsActionHandler = (data) => {
    return (dispatch) => {
        dispatch(SettingsActionWorkspaceAccessTokenRequestsRequest());
        try {
            SettingsActionWorkspaceAccessTokenRequestsApi(data)
                .then((res) => {
                    const errorMessage = res?.data?.message;
                    if (res) {
                        if (res && res.data && res.status === 200) {
                            dispatch(SettingsActionWorkspaceAccessTokenRequestsSuccess(res.data));
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: res?.response?.data?.data,
                            });
                            dispatch(SettingsActionWorkspaceAccessTokenRequestsError(errorMessage));
                        }
                    } else {
                        dispatch(SettingsActionWorkspaceAccessTokenRequestsError(errorMessage));
                    }
                })
                .catch((err) => {
                    dispatch(SettingsActionWorkspaceAccessTokenRequestsError("Something Went Wrong!!!"));
                });
        } catch (err) {
            dispatch(SettingsActionWorkspaceAccessTokenRequestsError(err));
        }
    };
};
